import AuthMixin from '@/components/mixins/auth-mixin'
import EventBus from '@/components/mixins/event-bus-mixin'

export default {
  name: 'logoutOk',
  mixins: [AuthMixin],
  computed: {},
  watch: {
    '$route' (routeTo) {
      this.setDefaultData({ routeChange: true })
    }
  },
  data () {
    return {
      providerName: null
    }
  },
  methods: {
    setDefaultData () {
      if (this.$route.params && this.$route.params.providerName) {
        this.providerName = this.$route.params.providerName
      }
    },
    handleSignInBtnClick () {
      if (!this.providerName) {
        EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
          type: 'error',
          alert: {
            message: this.$t('errors.invalid.provider')
          }
        })
        return
      }

      this.$router.push(`/sso/${this.providerName}`, () => {})
    }
  },
  async mounted () {
    this.setDefaultData()
    const session = await this.fetchAuthSession()
    if (session?.tokens?.accessToken) {
      this.$router.push('/menu', () => {})
    }
  }
}
